<template>
    <comp-form title="标签" ref="comp_form" submit-api="/gateway/api/sycompany/pc/label/createLabel" edit-api="/gateway/api/sycompany/pc/label/updateLabel" detail-api="/gateway/api/sycompany/pc/label/getLabelById" id-key="labelById" :submit-before="onSubmitBefore" :data-before="onDataBefore" @on-submit="onReset">
        <template v-slot:form-box="data">
            <elem-form-item title="标签名称" name="labelName">
                <template v-slot:default="item">
                    <Input style="width:300px" v-model.trim="data.form.labelName" :placeholder="item.cfg.ph"></Input>
                </template>
            </elem-form-item>
            <elem-form-item title="排序" name="sort">
                <template v-slot:default="item">
                    <Input style="width:300px" type="number" v-model.trim="data.form.sort" :placeholder="item.cfg.ph"></Input>
                </template>
            </elem-form-item>
            <elem-form-item title="背景色" name="bgColor">
                <template v-slot:default="item">
                    <Input style="width:300px" v-model.trim="data.form.bgColor" :placeholder="item.cfg.ph || '例如：#FFFFFF 或 rgb(255,255,255)'"></Input>
                </template>
            </elem-form-item>
            <elem-form-item title="跳转链接" name="jumpUrl">
                <template v-slot:default="item">
                    <Input style="width:300px" v-model.trim="data.form.jumpUrl" :placeholder="item.cfg.ph || '例如：https://example.com'"></Input>
                </template>
            </elem-form-item>
            <!-- <elem-form-item title="类型" name="labelType">
                <template v-slot:default="item">
                    <RadioGroup v-model="data.form.parentId" type="button" button-style="solid">
                        <Radio label="1">随心购</Radio>
                        <Radio label="2">乐龄通</Radio>
                    </RadioGroup>
                </template>
            </elem-form-item> -->
            <elem-form-item title="标签图标" name="icon">
                <elem-upload :value="data.form.icon" @on-change="onChangeIcon"></elem-upload>
            </elem-form-item>
        </template>
    </comp-form>
</template>

<script>
import CompForm from "../components/CompForm.vue"
import ElemUpload from "../components/elem-upload.vue"
import ElemFormItem from "../components/elem-form-item.vue"

export default {
    components: { CompForm, ElemUpload, ElemFormItem },

    methods: {
        /**
         * 打开表单窗口
         */
        open(id) {
            this.$refs.comp_form.open(id)
        },

        /**
         * 重置事件
         */
        onReset() {
            this.$emit("on-reset")
        },

        /**
         * 提交数据前置事件
         */
        onSubmitBefore(data) {
            data.oemCode = parent.vue.oemInfo.oemCode
            data.labelType = ""
            data.parentId = 0
            try {
                const ext = {}
                if (data.bgColor) ext.bgColor = data.bgColor
                if (data.jumpUrl) ext.jumpUrl = data.jumpUrl
                data.extInfo = Object.keys(ext).length ? JSON.stringify(ext) : null
            } catch (e) {
                data.extInfo = null
            }
            // 可根据后端要求移除表单中的临时字段
            // delete data.bgColor
            // delete data.jumpUrl
            return data
        },

        onDataBefore(d) {
            const data = { ...(d || {}) }
            if (data && typeof data.extInfo === "string") {
                try {
                    const ext = JSON.parse(data.extInfo || '{}')
                    if (ext && typeof ext === 'object') {
                        data.bgColor = ext.bgColor || data.bgColor
                        data.jumpUrl = ext.jumpUrl || data.jumpUrl
                    }
                } catch (e) {
                    // ignore parse error
                }
            }
            return data
        },

        onChangeIcon(e) {
            this.$refs.comp_form.setValue("icon", e.value.url)
        },
    },
}
</script>
